import React, { useState, useEffect } from 'react';
import { ChevronDown } from 'lucide-react';
import ParticleBackground from './components/ParticleBackground';
import ScrollProgressIndicator from './components/ScrollProgressIndicator';
import SectionUnlock from './components/SectionUnlock';
import Navigation from './components/Navigation';
import HeroSection from './sections/HeroSection';
import AboutSection from './sections/AboutSection';
import ProjectsSection from './sections/projects_section';
import CertificationsSection from './sections/CertificationsSection';
import TestimonialsSection from './sections/TestimonialsSection';
import AppealSection from './sections/AppealSection';
import ContactSection from './sections/ContactSection';
import { sections } from './data/sections';

const App = () => {
  const [currentSection, setCurrentSection] = useState('hero');
  const [showScrollHint, setShowScrollHint] = useState(true);
  const [scrollProgress, setScrollProgress] = useState(0);
  const [mousePos, setMousePos] = useState({ x: 0, y: 0 });
  const [unlockedSections, setUnlockedSections] = useState(new Set(['hero', 'about', 'projects', 'certifications', 'testimonials', 'appeal', 'contact']));
  // Mouse tracking for particles
  useEffect(() => {
    const handleMouseMove = (e) => {
      setMousePos({ x: e.clientX, y: e.clientY });
    };
    
    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  
         

  const scrollToSection = (sectionId) => {
    document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50 relative">
      {/* Particle Background */}
      <ParticleBackground mousePos={mousePos} />
      
      {/* Scroll Progress Indicator */}
      <ScrollProgressIndicator 
        scrollProgress={scrollProgress} 
        sections={sections}
        scrollToSection={scrollToSection}
        unlockedSections={unlockedSections}
      />
      
      {/* Navigation */}
      <Navigation 
        sections={sections}
        scrollToSection={scrollToSection}
        unlockedSections={unlockedSections}
      />

      {/* Hero Section */}
      <HeroSection 
        scrollToSection={scrollToSection}
        showScrollHint={showScrollHint}
      />

      {/* About Section */}
      <AboutSection unlockedSections={unlockedSections} />

      {/* Projects Section */}
      <ProjectsSection unlockedSections={unlockedSections} />

      {/* Certifications Section */}
      <CertificationsSection unlockedSections={unlockedSections} />

      {/* Testimonials Section */}
      <TestimonialsSection unlockedSections={unlockedSections} />

      {/* Appeal Section */}
      <AppealSection unlockedSections={unlockedSections} />

      {/* Contact Section */}
      <ContactSection unlockedSections={unlockedSections} />

      {/* Custom Styles */}
      <style jsx>{`
        .perspective-1000 {
          perspective: 1000px;
        }
        
        .transform-style-preserve-3d {
          transform-style: preserve-3d;
        }
        
        .backface-hidden {
          backface-visibility: hidden;
        }
        
        .rotate-y-180 {
          transform: rotateY(180deg);
        }
        
        .duration-3000 {
          transition-duration: 3000ms;
        }
        
        .animate-fade-in {
          animation: fadeIn 0.3s ease-in-out;
        }
        
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
};

export default App;